import "./App.css";
import "./asset/css/index.scss";
import { Route, Routes } from "react-router-dom";
import Header from "./hybrids/header/header";
import Home from "./views/Home/Home";
import Footer from "./hybrids/footer/Footer";
import {
  ABOUT_US_ROUTE,
  CONTACT_US_ROUTE,
  HOME_ROUTE,
  KEY_PERSONNEL_ROUTE,
  RESOURCES_ROUTE,
  SERVICES_ROUTE,
} from "./routes/routes";
import ServicesPage from "./views/Services/Services";
import AboutUs from "./views/AboutUs/AboutUs";
import Resources from "./views/Resources/Resources";
import KeyPersonnel from "./views/KeyPersonnel/KeyPersonnel";
import { CONTACT_US } from "./constants/translations";
import ContactUs from "./views/ContactUs/ContactUs";

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route index={true} path={HOME_ROUTE} element={<Home />} />
        <Route path={SERVICES_ROUTE} element={<ServicesPage />} />
        <Route path={ABOUT_US_ROUTE} element={<AboutUs />} />
        <Route path={RESOURCES_ROUTE} element={<Resources />} />
        <Route path={KEY_PERSONNEL_ROUTE} element={<KeyPersonnel />} />
        <Route path={CONTACT_US_ROUTE} element={<ContactUs />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
